import { query } from '@confluence/query-preloader-tools/entry-points/graphql';

import FooterCreateButtonsQuery, {
	type FooterCreateButtonsQuery$data,
	type FooterCreateButtonsQuery$variables,
} from './ContentTreeFooter/__generated__/FooterCreateButtonsQuery.graphql';

export function preloadFooterCreateButton(spaceKey: string) {
	return query<FooterCreateButtonsQuery$data, FooterCreateButtonsQuery$variables>({
		query: FooterCreateButtonsQuery,
		errorPolicy: 'all',
		variables: {
			spaceKey,
		},
	});
}
